import React, { HTMLProps } from 'react';
import { styled } from '@mui/material/styles';
import { Label } from '@cp/ui';
import { FormFieldSize } from './model';

const LabelRoot = styled(Label)<{ size: FormFieldSize }>(({ theme, size }) => ({
  ...(size === 'small' ? theme.typography['caption bold'] : theme.typography['body bold']),
}));

export interface FieldLabelProps extends Omit<HTMLProps<HTMLLabelElement>, 'size' | 'as'> {
  size: FormFieldSize;
}

export const FieldLabel: React.FC<React.PropsWithChildren<FieldLabelProps>> = (props) => <LabelRoot {...props} />;
